import React from 'react'

import Header from "../componets/Header";
import Footer from "../componets/Footer";
import Banner from "../componets/home/Banner";
import Grsf from "../componets/home/Grsf";
import Updates from "../componets/home/Updates";
import Redevelopment from "../componets/home/Redevelopment";
import Stakeholders from "../componets/home/Stakeholders";
import Process from "../componets/home/Process";
import Services from "../componets/home/Services";
import News from "../componets/home/News";
import Events from "../componets/home/Events";
import Faq from "../componets/home/Faq";
import Logos from "../componets/home/Logos";
import Connect from "../componets/home/Connect";

const Home = () => {
    return (
        <>
            <div className="bs-homepage">
                <Header />
                <Banner />
                <Grsf />
                <Updates />
                <Redevelopment />
                <Stakeholders />
                {/* <Process /> */}
                <Services />
                <News />
                <Events />
                <Faq />
                <Logos />
                <Connect />
                <Footer />
            </div>
        </>
    )
}

export default Home